import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { DataGridList } from '@components/DataGrid/DataGridList'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { Anchor } from '@mantine/core'

export const Invites = () => {
  const navigate = useNavigate()
  const handleNavigate = () =>
    navigate(`../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`, {
      state: {
        history: [
          {
            title: 'Community',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_INVITES}`,
          },
          {
            title: 'Invites',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_INVITES}`,
          },
        ],
      },
    })

  const data = Array(30)
    .fill(0)
    .map((_, i) => ({
      id: `invite-${i}`,
      email: (
        <Anchor href="mailto:alfredo@carrillo.com" size="sm" c="#000">
          alfredo@mybluecard.org
        </Anchor>
      ),
      persona: 'Contact',
      permissions: (
        <DataGridList title="Permissions" data={['Admin', 'Read', 'Write']} />
      ),
      invitedBy: 'Joseph Cadle',
      inviteSent: 'Mar 7, 2024',
      disabledBy: 'Liam Cadle',
      disabledOn: 'Mar 8, 2024',
      expires: 'Apr 7, 2024',
      status: 'Active',
    }))

  const columns: DataGridColumns[] = [
    {
      label: 'Email',
      prop: 'email',
      defaultSort: true,
      pinned: true,
    },
    {
      label: 'Persona',
      prop: 'persona',
    },
    {
      label: 'Persmissions',
      prop: 'permissions',
      unsortable: true,
    },
    {
      label: 'Invited By',
      prop: 'invitedBy',
    },
    {
      label: 'Invite sent',
      prop: 'inviteSent',
    },
    {
      label: 'Disabled by',
      prop: 'disabledBy',
    },
    {
      label: 'Disabled on',
      prop: 'disabledOn',
    },
    {
      label: 'Invite Expires',
      prop: 'expires',
    },
    {
      label: 'Invite Status',
      prop: 'status',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'All invites',
      href: '#',
      default: true,
    },
    {
      label: 'Contacts',
      href: '#',
    },
    {
      label: 'Staff',
      href: '#',
    },
    {
      label: 'Partners',
      href: '#',
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Resend invite',
      onClick: (item: any) => console.log('Actions: Resend Invite', item),
    },
    {
      label: 'Disable invite',
      color: 'red',
      onClick: (item: any) => console.log('Actions: Disable Invite', item),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Resend Invites',
      onClick: (items: any) => console.log('Selected Actions: Resend Invites'),
    },
    {
      label: 'Disable Invites',
      onClick: (items: any) => console.log('Selected Actions: Disable Invites'),
    },
  ]

  return (
    <DataGrid
      data={data}
      columns={columns}
      sections={sections}
      actions={actions}
      results={data.length}
      selectedActions={selectedActions}
      page={1}
    />
  )
}
